import { GraphNameValues, GraphName } from "../api/generated/api-types";
import { FormatName, FormatNameValues, ChartSettings, ChartSettingsY, ChartData, ChartDataX, ChartDataY } from './chart-models';

export const getXData = (data: any[], xKey: any, yKey: any): ChartDataX[] => {
    return (
        data.reduce((acc: any[], curr: any) => {
            const accLabel: any = acc.filter((item: any) => (item['label'] === curr[xKey]))[0]
            if (accLabel) {
                accLabel['total'] += curr[yKey];
            } else {
                acc.push({
                    label: curr[xKey],
                    total: +curr[yKey]
                })
            }
            return acc;
        }, [])
    )
}
export const getYData = (data: any[], x: ChartDataX[], xKey: any, yKey: any, stackKey: any): Array<Array<string|number>> => {
    return (
        data.reduce((acc: any[], curr: any) => {
            const slotIndex = x.map((item: any) => item['label']).indexOf(curr[xKey]); // x slot index [2013, 2014, 2015, X-2016-X, 2017]
            const yKeyName = (stackKey) ? curr[stackKey] : yKey;
            let arr = acc.filter((item: any) => item[0] === yKeyName)[0];
            if (!arr) {
                acc.push([yKeyName, ...Array(x.length).fill(0)]);
                arr = acc[acc.length - 1];
            }
            arr[slotIndex + 1] += curr[yKey];
            return acc;
        }, []) // [label, val, val, val]
    )
}
export const fixLabels = (chartData: any[], type: any): any[] => {
    switch (type) {
        case 'sugu':
            return (
                chartData.map((item: any) => {
                    if (item[0] === 'M' || item[0] === 1) { item[0] = 'Mehed'; return item; }
                    if (item[0] === 'N' || item[0] === 2) { item[0] = 'Naised'; return item; }
                })
            )
        case 'vanus':
            return (
                chartData.map((item: any) => {
                    if (item[0] === '-18') {
                        item[0] = 'Kuni 18 a.';
                    } else {
                        item[0] = item[0] + ' a.'
                    }
                    return item;
                })
            )
        case 'vanuseGrupp':
            return (
                chartData.map((item: any) => {
                    if (item[0] === '-18') {
                        item[0] = 'Kuni 18 a.';
                    } else {
                        item[0] = item[0] + ' a.'
                    }
                    return item;
                })
            )
        case 'tulugrupp':
            return (
                chartData.map((item: any) => {
                    if (item[0] === '-300') {
                        item[0] = '<300 €';
                    } else {
                        item[0] = item[0] + ' €';
                    }
                    return item;
                })
            )
        case 'sihtotstarve':
            return (
                chartData.map((item: any) => {
                    item[0] = item[0].split(' (')[0];
                    return item;
                })
            )
        default:
            return chartData;
    }
}
export const fixOrder = (chartData: any[], type: any): any[] => {
    switch (type) {
        case 'vanus':
            return (
                chartData.sort((a: any, b: any) => (!b[0]) ? 1 : (a[0] > b[0]) ? 1 : ((b[0] > a[0]) ? -1 : 0))
            )
        case 'vanuseGrupp':
            return (
                chartData.sort((a: any, b: any) => (!b[0]) ? 1 : (a[0] > b[0]) ? 1 : ((b[0] > a[0]) ? -1 : 0))
            )
        case 'tulugrupp':
            return (
                chartData.sort((a: any, b: any) => {
                    let a2 = a[0].split('-')[0];
                    let b2 = b[0].split('-')[0];
                    return(!+b2) ? 1 : (+a2 > +b2) ? 1 : ((+b2 > +a2) ? -1 : 0)
                })
            )
        case 'aasta':
            return (
                chartData.sort((a: any, b: any) => (!b['aasta']) ? 1 : (a['aasta'] > b['aasta']) ? 1 : ((b['aasta'] > a['aasta']) ? -1 : 0))
            )
        case 'seisuAasta':
            return (
                chartData.sort((a: any, b: any) => (!b['seisuAasta']) ? 1 : (a['seisuAasta'] > b['seisuAasta']) ? 1 : ((b['seisuAasta'] > a['seisuAasta']) ? -1 : 0))
            )
        default:
            return chartData;
    }
}
export const getPercentageDiff = (oldVal: number, newVal: number): number => {
    return 1 - (oldVal - newVal) / oldVal;
}
export const getPercentagShift = (oldVal: number, newVal: number): number => {
    return -(oldVal - newVal) / oldVal;
}
export const getPercent = (from: number, val: number): number => {
    return val / from * 100;
}
export const getChartObjInPercentage = (x: ChartDataX[], yData: any[]): any[] => {
    return (
        yData.map((item: any) => {
            return (
                item.map((subItem: any, index: any) => {
                    return (index > 0) ? getPercentageDiff(x[index - 1].total, subItem) : subItem;
                })
            )
        })
    )
}
export const getChartObjLimited = (x: ChartDataX[], yData: any[], limit: number): any[] => {
    const xTotal: number = x.reduce((acc: number, curr: any) => {
        if (curr) { acc += curr.total; }
        return acc;
    }, 0);
    const isEqualAboveLimitData = yData.filter((item: any) => {
        let yTotal = item.reduce((acc: any, curr: any, i: number) => {
            if (i === 0) { return acc; } // skip label
            if (curr) { acc += curr; } return acc;
        }, 0)
        return (getPercent(xTotal, yTotal) >= limit) ? true : false;
    });
    const isBelowLimitData = yData.filter((item: any) => {
        let yTotal = item.reduce((acc: any, curr: any, i: number) => {
            if (i === 0) { return acc; } // skip label
            if (curr) { acc += curr; } return acc;
        }, 0);
        return (getPercent(xTotal, yTotal) < limit) ? true : false;
    });
    const isBelowDataObj = isBelowLimitData.reduce((acc: any[], curr: any) => {
        curr.map((item: number, i: number) => {
            if (i === 0) { acc[i] = 'Muu'; return; }
            if (item) {
                if (acc[i]) {
                    acc[i] += item;
                } else {
                    acc[i] = item;
                }
            }
        })
        return acc;
    }, [])
    return [...isEqualAboveLimitData, isBelowDataObj];
}
export const getChartObj = (data: any[], x: any, y: any, viewType: number, graphName: string): {x: ChartDataX[], y: ChartDataY} => {
    // Modifiers
    const yFormat: FormatName = (Array.isArray(y.format)) ? y.format[viewType] : y.format;

    // ORDERBY PreData
    if (x.label === 'aasta') { data = fixOrder(data, 'aasta'); }
    if (x.label === 'seisuAasta') { data = fixOrder(data, 'seisuAasta'); }

    // PreData => ChartData
    const xData: ChartDataX[] = getXData(data, x.label, y.label);
    let yData: Array<Array<string|number>> = getYData(data, xData, x.label, y.label, y.group);

    // ORDERBY ChartData
    if (y.group && y.group === 'vanus') { yData = fixOrder(yData, 'vanus'); } // Age groups: Fix order
    if (y.group && y.group === 'vanuseGrupp') { yData = fixOrder(yData, 'vanuseGrupp'); } // Age groups: Fix order
    if (y.group && y.group === 'tulugrupp') { yData = fixOrder(yData, 'tulugrupp'); } // salary groups: Fix order

    // RENAME ChartData
    if (y.group === 'sugu') { yData = fixLabels(yData, 'sugu'); } // Gender: fix labels for display
    if (y.group && y.group === 'vanus') { yData = fixLabels(yData, 'vanus'); } // Age groups: Fix -18 label for display
    if (y.group && y.group === 'vanuseGrupp') { yData = fixLabels(yData, 'vanuseGrupp'); }
    if (y.group && y.group === 'tulugrupp') { yData = fixLabels(yData, 'tulugrupp'); }
    if (y.group && y.group === 'sihtotstarve') { yData = fixLabels(yData, 'sihtotstarve'); }
    if (x.label === 'aasta' || x.label === 'seisuAasta') { xData.map((item) => item.label = item.label + ' a.'); } // Add a.

    // Mutations
    if (y.limit) { yData = getChartObjLimited(xData, yData, y.limit) } // merge smaller objects
    if (yFormat === FormatNameValues.PERCENTAGE) { yData = getChartObjInPercentage(xData, yData) } // Convert values into percentages
    if (y.renameLabel) { yData[0][0] = y.renameLabel; }

    // return { xData, yData, yFormat }
    return {
        x: xData,
        y: {
            data: yData,
            format: yFormat,
            stacked: true,
            type: 'bar'
        }
    }
}
export const getPackage = (barData: any, lineData: any, config: ChartSettings, viewType: number, graphName: string): ChartData => {
    const main = getChartObj(barData, config.x, config.y, viewType, graphName);
    let second;
    if (config.y2 && main.y.format !== FormatNameValues.PERCENTAGE) {
        if(Array.isArray(config.y2)) {
            second = config.y2.reduce((acc: any[], curr: any) => {
                acc.push(getChartObj(lineData, config.x, curr, viewType, graphName));
                return acc;
            }, []).reduce((acc: any, curr: any) => {
                acc.y.data = [...acc.y.data, ...curr.y.data]
                acc.y.format = curr.y.format;
                return acc;
            }, {y: {data: []}})
            if(graphName === 'tulude-laekumine-ajas') {
                second.y.options = {fromZero: true};
            }
            if(graphName === 'tulude-laekumine-ajas-tax') {
                second.y.options = {fromZero: true};
            }
            if(graphName === 'tulude-potentsiaalne-laekumine' || graphName === 'tulude-jaotus-summa') {
                second.y.options = {fromZero: true};
            }
        } else {
            second = getChartObj(lineData, config.x, config.y2, viewType, graphName);
        }
    }
    switch (graphName) {
        case 'tulubaas':
            if (main.y.format !== FormatNameValues.PERCENTAGE) {
                second = {
                    y: {
                        data: [getGrowth('Tulubaasi kasv', main.x)],
                        format: FormatNameValues.PERCENTAGE,
                        stacked: true,
                        type: 'line'
                    }
                }
            }
            break;
        case 'maksutulud':
            if (main.y.format !== FormatNameValues.PERCENTAGE) {
                second = {
                    y: {
                        data: [getGrowth('Maksutulu kasv', main.x)],
                        format: FormatNameValues.PERCENTAGE,
                        stacked: true,
                        type: 'line'
                    }
                }
            }
            break;
        case 'toohoive-asukoht':
            main.y.stacked = false;
            break;
    }
    if(main.x.length === 1 && main.y.format === FormatNameValues.PERCENTAGE) { main.y.type = 'pie' }

    // Limit output to five
    const y2 = (second) ? second.y : { data: [], format: FormatNameValues.NULL, type: 'line', stacked: true }

    const limitedXData = limitToFive('x', main.x);
    const limitedYData = limitToFive('y', main.y.data);
    const limitedY2Data = limitToFive('y', y2.data);

    // return ({
    //     x: main.x,
    //     y: main.y,
    //     y2: (second) ? second.y : { data: [], format: FormatNameValues.NULL, type: 'line', stacked: true }
    // });
    return ({
        x: limitedXData,
        y: {...main.y, data: limitedYData},
        y2: {...y2, data: limitedY2Data}
    });
}

export const limitToFive = (type: 'x' | 'y' | 'y2', data: any) => {
    switch (type) {
        case 'x':
            // if(data.length <= 5) return data;
            return data.slice(Math.max(data.length - 5, 0));
        case 'y':
        case 'y2':
            if(!data.length) { return data; }
            return data.map((subdata: any[]) => [subdata[0], ...subdata.slice(Math.max(subdata.length - 5, 1))]);;
    }
}

/* Additional  */

export const getRange = (data: Array<any>, key: string): Array<number> => {
    return data.reduce((acc: Array<any>, curr: any) => {
        if (acc.indexOf(curr[key]) === -1) {
            acc.push(curr[key]);
        }
        return acc;
    }, [])
}
export const getGrowth = (key: string, x: ChartDataX[]) => {
    let inPercentage: Array<any> = [];
    for (var i = 0; i < x.length; i++) {
        if (i === 0) { inPercentage[i] = 0; }
        else { inPercentage[i] = getPercentagShift(x[i - 1]['total'], x[i]['total']) }
    }
    // avoid negative incorrect percantages when year is still ongoing
    const currYear = new Date().getFullYear().toString();
    if(x[x.length-1].label.indexOf(currYear) !== -1) {
        inPercentage[inPercentage.length-1] = null;
    }
    return [key, ...inPercentage];
}

/* Pot. FIT Methods */

export const addInterest = (curr: number, percent: number): number => {
    return +(curr * (1 + percent/100)).toFixed(2);
}
export const getPercentage = (sum: number, percent: number): number => {
    return +(sum * (percent/100));
}



// WEBPACK FOOTER //
// ./src/core/chart-methods.ts